import React from 'react';
import './loading.css';

const Loading = () => (
    <div className="loadingio-spinner-spinner-vowi5is1eb8"><div className="ldio-hv6mvf02q05">
        <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
    </div></div>
)

export default Loading;